export enum CALENDAR_DATE_RANGE {
  PREV = 'prev',
  NEXT = 'next',
  TODAY = 'today',
}
